import PropTypes from 'prop-types'
import { createContext, memo, useContext } from 'react'
import useWallet from './hooks/useWallet'

export const WalletContext = createContext({})

export const useWalletContext = () => {
  const context = useContext(WalletContext)

  return context
}

/**
 * The `WalletProvider`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the react element
 */
function WalletProvider (props) {
  const { children } = props
  const ctx = useWallet()

  return (
    <WalletContext.Provider value={ctx}>{children}</WalletContext.Provider>
  )
}

/** @type {object} */
WalletProvider.propTypes = {
  children: PropTypes.node
}

/** @type {object} */
WalletProvider.defaultProps = {
  children: []
}

// Memoize
export default memo(WalletProvider)
